import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { extractNestJsErrorMessage } from '../../../shared/api/rtk-query';
import { callsApi } from './calls.api';
import { emptyPagedCollection, EventCallsDto, IPagingData } from '@sr/dto';

export const useCallsList = (pagination: IPagingData, filter?: URLSearchParams,) => {

  const { data, isLoading, error } = callsApi.useGetCallsListQuery(
    { paging: pagination, filter: filter?.toString() || '' },
    { refetchOnMountOrArgChange: true });

  const result: IRemotePagedCollection<EventCallsDto> = {
    collection: data || emptyPagedCollection,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };

  return result;
}
